import { createSlice } from "@reduxjs/toolkit";
import {
  fetchReceipts,
  fetchReceiptCode,
  fetchDueVouchers,
  fetchDueEmis,
  fetchCustomerBalance,
  saveReceipt,
  deleteReceipt,
  fetchDirectExpenseAccounts,
  fetchDuePurchaseReturns,
} from "./customerReceiptThunk";
import { currentDateTime } from "../../lib/functions";

const initialState = {
  entryDate: currentDateTime(),
  receipts: [],
  receiptCode: "",
  dueVouchers: {},
  dueEmis: {},
  balances: {},
  directExpense: null,
  loading: false,
  error: null,
  duePurchaseReturns: {},
  selectedReceipt: null, // 🔹 for editing
  isEditReceipt: false,
};

const customerReceiptSlice = createSlice({
  name: "customerReceipts",
  initialState,
  reducers: {
    resetReceipts: () => initialState,
    setPaymentCode(state, action) {
      state.receiptCode = action.payload;
    },
    setEntryDate(state, action) {
      state.entryDate = action.payload;
    },
    setSelectedReceipt(state, action) {
      state.selectedReceipt = action.payload;
    },
    setIsEditReceipt(state, action) {
      state.isEditReceipt = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReceipts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReceipts.fulfilled, (state, action) => {
        state.loading = false;
        state.receipts = action.payload;
      })
      .addCase(fetchReceipts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchReceiptCode.fulfilled, (state, action) => {
        state.receiptCode = action.payload;
      })
      .addCase(fetchDueVouchers.fulfilled, (state, action) => {
        state.dueVouchers[action.payload.customerId] = action.payload.vouchers;
      })
      .addCase(fetchDueEmis.fulfilled, (state, action) => {
        state.dueEmis = action.payload.emis;
      })
      .addCase(fetchCustomerBalance.fulfilled, (state, action) => {
        state.balances[action.payload.customerId] = action.payload.balance;
      })
      .addCase(saveReceipt.fulfilled, (state, action) => {
        state.receipts.push(action.payload);
      })
      .addCase(deleteReceipt.fulfilled, (state, action) => {
        state.receipts = state.receipts.filter(
          (r) => r.rcv_id !== action.payload.id
        );
      })
      .addCase(fetchDuePurchaseReturns.fulfilled, (state, action) => {
  state.duePurchaseReturns[action.payload.supplierId] = action.payload.returns;
})
      .addCase(fetchDirectExpenseAccounts.fulfilled, (state, action) => {
        state.directExpense = action.payload;
      });
  },
});

export const {
  resetReceipts,
  setEntryDate,
  setSelectedReceipt,
  setIsEditReceipt,
  setPaymentCode
} = customerReceiptSlice.actions;
export default customerReceiptSlice.reducer;
